import { render, staticRenderFns } from "./SellerData.vue?vue&type=template&id=dc41072c&scoped=true"
import script from "./SellerData.vue?vue&type=script&lang=js"
export * from "./SellerData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc41072c",
  null
  
)

export default component.exports